import React, { useEffect, useState } from "react";

export default function Stat(props: any) {
  return (
    <div className="z-0 ">
      {/* Web Design */}
      <div className="hidden lg:flex ">
        <div className="w-full flex px-customPadding mt-[13px] pt-[92px] pb-customPadding 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <div className="space-y-4 py-1 w-[220px] max-w-[220px]">
            <img
              src="Stats1.png"
              className=""
              alt=""
              height={"36px"}
              width={"82px"}
            />
            <p className="font-spaceGrotesk font-normal mid:text-web-h2 mid:leading-[60px] text-brand-textBlack text-[40px] leading-10">
              10,000+
            </p>
            <p className="font-openSans font-normal mid:text-web-subheading leading-6 text-brand-textGrey text-web-body-lg">
              people subscribed across India to our website
            </p>
          </div>
          <div
            className="bg-brand-lightBlue ml-auto mid:pl-[97px] mid:pr-[59px] pl-20 pr-10   py-[46px]"
            style={{
              clipPath: "polygon(6% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 40%)",
            }}
          >
            <div className="flex mid:gap-[68px] mx-auto gap-14">
              <div className="mid:max-w-[118px] max-w-[100px]">
                <div className="font-openSans font-normal mid:text-[22px] mid:leading-[50px] leading-10 text-brand-textBlack text-web-subheading">
                  1000+
                </div>
                <div className="font-openSans font-normal mid:text-web-body-lg leading-6 text-brand-textGrey text-web-body-md">
                  Happy Investors
                </div>
              </div>
              <div className="mid:max-w-[122px] max-w-[100px]">
                <div className="font-openSans font-normal mid:text-[22px] mid:leading-[50px] leading-10 text-brand-textBlack text-web-subheading">
                  500 Cr+
                </div>
                <div className="font-openSans font-normal mid:text-web-body-lg leading-6 text-brand-textGrey text-web-body-md">
                  Value Recovered
                </div>
              </div>
              <div className="mid:max-w-[156px] max-w-[130px]">
                <div className="font-openSans font-normal mid:text-[22px] mid:leading-[50px] leading-10 text-brand-textBlack text-web-subheading">
                  50+
                </div>
                <div className="font-openSans font-normal mid:text-web-body-lg leading-6 text-brand-textGrey text-web-body-md">
                  Years of Cumulative Experience
                </div>
              </div>
              <div className="mid:max-w-[142px] max-w-[100px]">
                <div className="font-openSans font-normal mid:text-[22px] mid:leading-[50px] leading-10 text-brand-textBlack text-web-subheading">
                  5000+
                </div>
                <div className="font-openSans font-normal mid:text-web-body-lg leading-6 text-brand-textGrey text-web-body-md">
                  Investment Options
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Design */}
      <div className="lg:hidden ">
        <div className="w-full px-customPaddingMobile mt-4 py-[42px]">
          <div className=" pl-[22px] max-w-[331px]">
            <img
              src="Stats1.png"
              className=""
              alt=""
              height={"36px"}
              width={"82px"}
            />
            <p className="font-spaceGrotesk mt-2 font-normal text-[42px] leading-[59px] text-brand-textBlack">
              10,000+
            </p>
            <p className="font-openSans font-normal  leading-[22px] text-brand-textGrey text-mobile-body-lg">
              People subscribed across India to our website
            </p>
          </div>
          <div
            className="bg-brand-lightBlue  grid grid-cols-2 p-[26px] gap-[31px] mt-5"
            style={{
              clipPath: "polygon(0% 0%, 100% 0%, 100% 60%, 85% 100%, 0% 100%)",
            }}
          >
            <div className="">
              <div className="font-openSans mb-1 font-normal text-[20px] leading-[27px] text-brand-textBlack">
                1000+
              </div>
              <div className="font-openSans font-normal leading-5 text-brand-textGrey text-web-body-md">
                Happy Investors
              </div>
            </div>
            <div className="">
              <div className="font-openSans mb-1 font-normal text-[20px] leading-[27px] text-brand-textBlack">
                500 Cr+
              </div>
              <div className="font-openSans font-normal leading-5 text-brand-textGrey text-web-body-md">
                Value Recovered
              </div>
            </div>
            <div className="max-w-[131px]">
              <div className="font-openSans mb-1 font-normal text-[20px] leading-[27px] text-brand-textBlack">
                50+
              </div>
              <div className="font-openSans font-normal leading-5 text-brand-textGrey text-web-body-md">
                Years of Cumulative Experience
              </div>
            </div>
            <div className="">
              <div className="font-openSans mb-1 font-normal text-[20px] leading-[27px] text-brand-textBlack">
                5000+
              </div>
              <div className="font-openSans font-normal leading-5 text-brand-textGrey text-web-body-md">
                Investment Options
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
